module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/buy-item-button/buy-item-button.component.scss
// module id = ./src/app/shared/buy-item-button/buy-item-button.component.scss
// module chunks = main